import { render } from "./roomFacilities.vue?vue&type=template&id=00059f42&scoped=true"
import script from "./roomFacilities.vue?vue&type=script&lang=js"
export * from "./roomFacilities.vue?vue&type=script&lang=js"

import "./roomFacilities.vue?vue&type=style&index=0&id=00059f42&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00059f42"]])

export default __exports__